import { ForgetResumeDecisionWhenSignedOut } from '@/features/onboarding-chat/components/ForgetResumeDecisionWhenSignedOut';
import { LoginGate } from '@/features/onboarding-chat/components/LoginGate';
import { OnboardingChat } from '@/features/onboarding-chat/components/OnboardingChat';
import { ResumeGate } from '@/features/onboarding-chat/components/ResumeGate';
import { AuthProvider, useAuth } from '@/lib/context/auth-context';
import { roleLabelFromGroups } from '@/lib/operator-identity';

/** The chat for the signed-in operator: their email keys the browser session, so it is never shown to anyone else. */
function OperatorChat() {
  const { user, groups } = useAuth();
  // The account row shows only what the login session gave: their name and e-mail, and the role their Cognito groups stand for.
  const operator = {
    name: user?.profile.firstName,
    email: user?.email,
    role: roleLabelFromGroups(groups) ?? undefined,
  };
  return (
    <ResumeGate ownerKey={user?.email ?? null} operator={operator}>
      <OnboardingChat ownerKey={user?.email ?? null} operator={operator} />
    </ResumeGate>
  );
}

/** /onboarding: the chat, behind the operator sign-in (P6: access stays operator-only). */
export default function OnboardingChatPage() {
  return (
    <AuthProvider>
      <ForgetResumeDecisionWhenSignedOut />
      <LoginGate>
        <OperatorChat />
      </LoginGate>
    </AuthProvider>
  );
}
